import { render, staticRenderFns } from "./TopicDailyChanges.vue?vue&type=template&id=73808bc3&scoped=true"
import script from "./TopicDailyChanges.vue?vue&type=script&lang=js"
export * from "./TopicDailyChanges.vue?vue&type=script&lang=js"
import style0 from "./TopicDailyChanges.vue?vue&type=style&index=0&id=73808bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73808bc3",
  null
  
)

export default component.exports